import { makePasswordGeneratorUseCases } from "@app/teamMembers";
import { teamMembersApi } from "./missionControl";

export const passwordGeneratorUseCases = makePasswordGeneratorUseCases({ teamMembersApi });
